'use es6';

import noAuthApiClient from 'hub-http/clients/noAuthApiClient';
import createPublicI18nProvider from 'I18n/init/providers/createPublicI18nProvider';
import { createTracker } from 'usage-tracker-public';
import { setAppContext } from 'ecosystem-marketplace-solutions-base/actions/AppActions';
import * as AppContext from 'ecosystem-marketplace-solutions-base/constants/AppContext';
import { getTrackerConfig, setTracker } from 'ecosystem-marketplace-solutions-base/utils/usageTracker';
import { setApiClient } from 'ecosystem-marketplace-solutions-base/utils/apiClient';
import { setEcosystemApiBase } from 'ecosystem-marketplace-solutions-base/clients/ecosystemClient';
import { setProfilesApiBase } from 'ecosystem-marketplace-solutions-base/clients/profilesClient';
import { getPublicRootUrl } from 'ecosystem-marketplace-solutions-base/utils/urls';
import BaseApp from 'ecosystem-marketplace-solutions-base/App';
import Application from './containers/Application';
import rhumbConfig from '../rhumb-config.yaml';
export default class PublicApp extends BaseApp {
  initialize() {
    const promises = [];
    setEcosystemApiBase('ecosystem/public/v1');
    setProfilesApiBase('marketplace/profiles/public/v1');
    this.setAppContext();
    this.setApiClient();
    this.setUsageTracker();
    const [I18nProvider, langAvailable] = this.setupI18n();
    I18nProvider.setLocale({
      locale: this.getLocale(),
      langEnabled: true
    });
    promises.push(langAvailable);
    return Promise.all(promises);
  }

  setupI18n() {
    const I18nProvider = createPublicI18nProvider({
      manuallySetLocale: true
    });
    const langAvailable = this.registerI18n(I18nProvider);
    return [I18nProvider, langAvailable];
  }

  setAppContext() {
    this.store.dispatch(setAppContext(AppContext.PUBLIC));
  }

  setApiClient() {
    setApiClient(noAuthApiClient);
  }

  setUsageTracker() {
    const config = getTrackerConfig('public');
    config.isExternalHost = false;
    setTracker(createTracker(config));
  }

  getLocale() {
    return window.I18N_MANUAL_LANG || 'en';
  }

  getRootUrl() {
    return getPublicRootUrl(this.getLocale());
  }

  getRhumbConfig() {
    return rhumbConfig;
  }

  getApplicationComponent() {
    return Application;
  }

}